import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'guided',
    pathMatch: 'full'
  },
  {
    path: 'guided',
    loadChildren: () => import('./guided-cv-builder/guided-cv-builder.module').then(mod => mod.GuidedCvBuilderModule),
    data: { title: 'Guided CV builder' }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CvBuilderRoutingModule { }
